/* eslint-disable no-tabs */
import React from 'react';
import PropTypes from 'prop-types';

const GraphIcon = ({ fill, style }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 26 21.001"
    style={{ enableBackground: 'new 0 0 26 21.001', ...style }}
    xmlSpace="preserve"
  >
    <path
      id="Path_714"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fill}
      d="M10.636,0h4.727
	c0.648-0.005,1.177,0.516,1.182,1.164c0,0.001,0,0.002,0,0.003v4.667c-0.004,0.648-0.533,1.171-1.181,1.167c0,0-0.001,0-0.001,0
	H13.59v2.625h9.455V14h1.773c0.648-0.005,1.177,0.516,1.182,1.164c0,0.001,0,0.002,0,0.003v4.667
	c-0.004,0.648-0.533,1.171-1.181,1.167c0,0-0.001,0-0.001,0h-4.727c-0.649,0.004-1.178-0.518-1.182-1.167v-4.667
	c0.004-0.648,0.533-1.171,1.181-1.167c0,0,0.001,0,0.001,0h1.773v-3.2h-8.273V14h1.773c0.648-0.005,1.177,0.516,1.182,1.164
	c0,0.001,0,0.002,0,0.003v4.667c-0.004,0.648-0.533,1.171-1.181,1.167c0,0-0.001,0-0.001,0h-4.728
	c-0.649,0.004-1.178-0.518-1.182-1.167v-4.667c0.004-0.648,0.533-1.171,1.181-1.167c0,0,0.001,0,0.001,0h1.773v-3.2H4.136V14h1.773
	c0.648-0.005,1.177,0.516,1.182,1.164c0,0.001,0,0.002,0,0.003v4.667c-0.004,0.648-0.533,1.171-1.181,1.167c0,0-0.001,0-0.001,0
	H1.182C0.533,21.005,0.004,20.483,0,19.834v-4.667C0.004,14.519,0.533,13.996,1.181,14c0,0,0.001,0,0.001,0h1.773V9.625h9.455V7
	h-1.774C9.987,7.004,9.458,6.482,9.454,5.833V1.166C9.458,0.518,9.988-0.004,10.636,0L10.636,0z"
    />
  </svg>
);

GraphIcon.propTypes = {
  fill: PropTypes.string.isRequired,
  style: PropTypes.object,
};

GraphIcon.defaultProps = {
  style: {},
};

export default GraphIcon;



// WEBPACK FOOTER //
// ./src/assets/GraphIcon.jsx